import React, { Component } from "react";
import $ from 'jquery'
import { Link } from "react-router-dom";
import { resetPasswords } from '../../actions/loginActions'
import { MediaBaseUrl } from "../../actions/api";
import { FontAwesomeIcon } from "../CommonComponents/AssetsHelper";

class ResetPassword extends Component {
    constructor(props) {
        super(props)
    }
    state = {
        accountPassword: null,
        passwordError: null,
        accountRePassword: null,
        passwordReError: null,
        success: false,
        successMessage: null,
        loader : false
    }
    onEmailTextChange = event => {
        this.setState({ accountPassword: event.target.value, emailError: null })
    }
    onPasswordReTextChange = event => {
        this.setState({ accountRePassword: event.target.value, passwordReError: null })
    }
    onClickToResetPassword = event => {
        const { accountPassword, accountRePassword  } = this.state;
        const { token, userId } = this.props.params;
        var self = this;
        if (accountPassword && String(accountPassword).length > 0 && accountRePassword && String(accountRePassword).length > 0) {

            this.setState({ passwordError: false,passwordReError:false })
            if(accountPassword==accountRePassword){
             self.setState({loader:true})   
              resetPasswords({ userId: userId, token: token, password: accountPassword }).then((response) => {
                self.setState({ loader:false,success: true,successMessage:"" })
              }).catch((data)=>{
                 self.setState({loader:false,successMessage : 'Sorry !! Reset password Url expired !'});
                })
             }else{
             self.setState({successMessage : "Sorry !! Password & Re-type password doesn't Match"});
          }  
        }
        else {
           this.setState({ passwordError: true, passwordReError: true})
        }
    }

    validatePassword = event => {
        let password = event.target.value;
        $('#register-submit-btn').attr('disabled', true);
        $('#popover-password').show();
        var strength = 0;

        //If password contains both lower and uppercase characters, increase strength value.
        if (password.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/)) {
            strength += 1;
            $('.low-upper-case').parent().addClass('active');
            $('#popover-password-top').addClass('hide');
        } else {
            $('.low-upper-case').parent().removeClass('active');
            $('#popover-password-top').removeClass('hide');
        }

        if (password.match(/([0-9])/)) {
            strength += 1;
            $('.one-number').parent().addClass('active');
            $('#popover-password-top').addClass('hide');
        } else {
            $('.one-number').parent().removeClass('active');
            $('#popover-password-top').removeClass('hide');
        }

        //If it has one special character, increase strength value.
        if (password.match(/([!,%,&,@,#,$,^,*,?,_,~])/)) {
            strength += 1;
            $('.one-special-char').parent().addClass('active');
            $('#popover-password-top').addClass('hide');
        } else {
            $('.one-special-char').parent().removeClass('active');
            $('#popover-password-top').removeClass('hide');
        }

        if (password.length > 7) {
            strength += 1;
            $('.eight-character').parent().addClass('active');
            $('#popover-password-top').addClass('hide');
        } else {
            $('.eight-character').parent().removeClass('active');
            $('#popover-password-top').removeClass('hide');
        }

        // If value is less than 2
        if (strength == 0) {
            $('#result').removeClass()
            $('#password-strength').addClass('progress-bar-danger');
            $('#result').addClass('text-danger').text('');
            $('#password-strength').css('width', '0%');
            this.setState({ passwordError: true, passwordReError: true})
        } else if (strength == 1) {
            $('#result').removeClass()
            $('#password-strength').removeClass('progress-bar-warning');
            $('#password-strength').addClass('progress-bar-danger');
            $('#result').addClass('text-danger').text('Weak');
            $('#password-strength').css('width', '10%');
        } else if (strength == 2 || strength == 3) {
            $('#result').addClass('good');
            $('#password-strength').removeClass('progress-bar-danger');
            $('#password-strength').removeClass('progress-bar-success');
            $('#password-strength').addClass('progress-bar-warning');
            $('#result').addClass('text-warning').text('Average')
            $('#password-strength').css('width', '60%');
        } else if (strength == 4) {
            $('#register-submit-btn').attr('disabled', false);
            $('#result').removeClass()
            $('#result').addClass('strong');
            $('#password-strength').removeClass('progress-bar-warning');
            $('#password-strength').removeClass('progress-bar-danger');
            $('#password-strength').addClass('progress-bar-success');
            $('#result').addClass('text-success').text('Strong');
            $('#password-strength').css('width', '100%');
            this.setState({ accountPassword: password,passwordError: false })
        }
    }

    showPass = (event) => {  
        var x = document.getElementById(`Account${event}`);
        var element = document.getElementById(`show_password_icon_${event}`);
        element.classList.toggle("view_pass");

        if (x.type === "password") {
            x.type = "text";
        } else {
            x.type = "password";
        }
    }

    render() {
        const { prefix } = this.props
        const { passwordError, success,successMessage, accountRePassword, passwordReError, loader } = this.state

        return <>
            <div className="loginFormSec formControlMin">
                <div className="loginBlock">
                    <div className="loginInnSec">

                        <div className="resetPassForm">
                            <div className="loginHead">
                                <h2>Reset Password?</h2>
                                {!success ? <p>For existing user</p> : null}
                            </div>

                            { success ? <div id="flashFlushMessage" className="note note-success">
                                  <p className="mb-0">
                                    You have successfully updated your password. You can login now with your new password.
                                    </p>
                             </div> : 

                               !success ?  successMessage ? <div id="flashFlushMessage" className="alert alert-block alert-danger flashNotification">
                                <p className="mb-0"> {successMessage} </p>
                               </div> :  <p className="text-center"><strong> Enter your new password below to reset your account password. </strong></p> : null
                            }

                            <div className="spacer20px"></div>
                            <div>
                                {!success ? <>
                                    <div className="form-group labelPosition">
                                        <label htmlFor="AccountPassword">Password</label>
                                        <div className="password_wrap"><input name="data[Account][password]" className={`form-control placeholder-no-fix ${passwordError ? `form-error` : ``}`} autoComplete={'off'} onKeyUp={this.validatePassword} type="password" minlength="8" maxlength="24" id="AccountPassword" />
                                            <button id="show_password_icon_Password" type="button" className="show_password_icon" onClick={()=>this.showPass('Password')} data-factors-form-bind="true" data-factors-click-bind="true">
                                                <FontAwesomeIcon type={'regular'} icon={'eye'} iconClass={'text-gray-500'} />
                                                <FontAwesomeIcon type={'regular'} icon={'eye-slash'} iconClass={'text-gray-500'} />
                                            </button>
                                        </div>
                                        {passwordError ? <div className="error-message">Password is required</div> : null}
                                    </div>
                                    <div className="form-group labelPosition">
                                        <label htmlFor="AccountRpassword">Re-type Your Password</label>
                                        <div className="password_wrap">
                                            <input name="data[Account][rpassword]" className={`form-control placeholder-no-fix ${passwordReError ? `form-error` : ``}`} autoComplete={'off'} type="password" id="AccountRpassword" minlength="8" maxlength="24" value={accountRePassword} onChange={this.onPasswordReTextChange} />
                                            <button id="show_password_icon_Rpassword" type="button" className="show_password_icon" onClick={()=>this.showPass('Rpassword')} data-factors-form-bind="true" data-factors-click-bind="true">
                                                <img className="img-responsive" src={`${MediaBaseUrl}icons/svg-icons/view.svg`} width="22" height="18"/>
                                            </button>
                                        </div>
                                        {passwordReError ? <div className="error-message">Password is required</div> : null}
                                    </div>
                                    <div id="popover-password" style={{ display: 'none' }}>
                                        <p style={{ textAlign: 'left' }}>Strength: <span id="result"></span></p>
                                        <div className="progress">
                                            <div id="password-strength" className="progress-bar progress-bar-success" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style={{ width: '0%' }}>
                                            </div>
                                        </div>
                                        <ul className="list-unstyled verified_checkpoints">
                                            <li><span className="low-upper-case">
                                                <i className="point_ver__"></i>
                                            </span>Upper Case & Lower Case Alphabets (A-z)</li>
                                            <li><span className="one-number">
                                                <i className="point_ver__"></i>
                                            </span>1 Number (0-9)</li>
                                            <li><span className="one-special-char">
                                                <i className="point_ver__"></i>
                                            </span>1 Special symbol (!@#$&*)</li>
                                            <li><span className="eight-character">
                                                <i className="point_ver__"></i>
                                            </span>Minimum 8 Characters</li>
                                        </ul>
                                    </div>
                                    <div className="form-group">
                                        <button className={`btn btn-primary w-100 ${loader ? ' disabled' : ''}`} data-style="expand-left" onClick={this.onClickToResetPassword}><span className="ladda-label changeText" style={{ display: loader ? 'none' : 'block' }}>Submit</span>
                                        
                                        <span className="indicator-progress" style={{ display: !loader ? 'none' : 'block' }}> Please wait...
                                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                          </span>
                                        </button>
                                    </div>
                                </> : null}
                                
                                <div className="form-group">
                                    <p>Take me back to <Link to={`${prefix}accounts/login`} className="btnSignUp">Login</Link></p>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    }
}

export default ResetPassword